import React, { useState } from 'react';
import SharedHelmet from '../Helmet';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Acceleration Calculator - Calculate Acceleration Based on Change in Velocity and Time';
const DESCRIPTION = 'The acceleration calculator calculates acceleration based on the change in velocity and time.';
const KEYWORDS = 'Acceleration calculation, acceleration calculator, calculate acceleration based on change in velocity and time';
const OG_URL = 'https://do-calculate.com/calculator/en/acceleration';
function AccelerationCalculator() {
    const [initialVelocity, setInitialVelocity] = useState('');
    const [finalVelocity, setFinalVelocity] = useState('');
    const [time, setTime] = useState('');
    const [acceleration, setAcceleration] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!initialVelocity || !finalVelocity || !time) {
            setError('Please enter the initial velocity, final velocity, and time correctly.');
            setAcceleration('');
            return;
        }
        const initialVelocityValue = parseFloat(initialVelocity);
        const finalVelocityValue = parseFloat(finalVelocity);
        const timeValue = parseFloat(time);
        if (isNaN(initialVelocityValue) || isNaN(finalVelocityValue) || isNaN(timeValue)) {
            setError('Please enter valid values for initial velocity, final velocity, and time.');
            setAcceleration('');
            return;
        }
        const deltaVelocity = finalVelocityValue - initialVelocityValue;
        const deltaT = timeValue;
        const accelerationValue = deltaVelocity / deltaT;
        setAcceleration(accelerationValue.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />                 </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            Welcome! Acceleration can be expressed mathematically using two main laws based on the given data. In this case, we use the following law:
                                        </p>
                                        <p>
                                            Acceleration = Change in Velocity / Change in Time
                                        </p>
                                        <p>
                                            a = ∆v / ∆t
                                        </p>
                                        <p>
                                            Where:
                                        </p>
                                        <ul>
                                            <li>a: Acceleration, measured in m/s².</li>
                                            <li>∆v: Change in velocity (final velocity - initial velocity), measured in m/s.</li>
                                            <li>∆t: Change in time (final time - initial time), measured in seconds.</li>
                                        </ul>
                                        <p>
                                            To calculate acceleration, enter the required values and click "Calculate Acceleration" to get the result.
                                        </p>
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Initial Velocity (m/s)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="0"
                                                        value={initialVelocity}
                                                        onChange={(e) => setInitialVelocity(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Final Velocity (m/s)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="60"
                                                        value={finalVelocity}
                                                        onChange={(e) => setFinalVelocity(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Time (seconds)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="4"
                                                        value={time}
                                                        onChange={(e) => setTime(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Acceleration
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {acceleration !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Acceleration (m/s²): {acceleration}
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>
                                                                    Solution Steps: <br />
                                                                    - Writing the law: Acceleration = Change in Velocity / Change in Time
                                                                    - Substituting the data and calculating the result.
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <RelatedLinks />                             </div>
                </div>
                <div className="col" >
                    <SecondAds />                     <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>                                          <br />
                </div>
            </div>
        </div>
    );
}
export default AccelerationCalculator;
